<template>
  <a-layout class="fundDetails">
    <a-layout-header>
      <PageNav></PageNav>
    </a-layout-header>
    <a-layout-content>
      <div class="_body">
        <div class="label">
          <p class="title">{{ $t('investment.product_details') }}</p>
          <div class="card">
            <div class="row">
              <div class="flex align-center">
                <img src="@/assets/images/coin/usdt.png" alt="">
                <span class="font-18 color-black font-bold">{{ $t('investment.usdt_enhanced_yield_selected') }}</span>
              </div>
              <a-button class="button">{{ $t('investment.subscribe_now') }}</a-button>
            </div>
            <div class="column">
              <div class="item">
                <p class="font-16 color-gray">{{ $t('investment.expected_annual_return') }}</p>
                <span class="font-24 color-black font-bold">8%-40%</span>
              </div>
              <div class="item">
                <p class="font-16 color-gray">{{ $t('investment.unit_net_value') }}（2023-09-25）</p>
                <span class="font-24 color-green font-bold">0.99759137 <span class="font-16 color-green">+0.0128%</span></span>
              </div>
              <div class="item">
                <p class="font-16 color-gray">{{ $t('investment.cumulative_return_rate') }}（2023-09-25）</p>
                <span class="font-24 color-red font-bold">-0.9634 %</span>
              </div>
            </div>
            <div class="row">
              <div class="flex align-center">
                <span class="font-16 color-gray">{{ $t('investment.fund_type') }}</span>
                <a-tag color="orange" class="tag">{{ $t('investment.medium_low_risk') }}</a-tag>
              </div>
            </div>
            <div class="column">
              <div class="item">
                <p class="color-gray font-16">{{ $t('investment.minimum_purchase') }}</p>
                <span class="color-black font-16">10,000 USDT</span>
              </div>
              <div class="item">
                <p class="color-gray font-16">{{ $t('investment.total_amount') }}</p>
                <span class="color-black font-16">10,000 USDT</span>
              </div>
              <div class="item">
                <p class="color-gray font-16">{{ $t('investment.establishment_date') }}</p>
                <span class="color-black font-16">2023-05-02</span>
              </div>
              <div class="item">
                <p class="color-gray font-16">{{ $t('investment.subscription_open_time') }}</p>
                <span class="color-black font-16">2023-05-02</span>
              </div>
              <div class="item">
                <p class="color-gray font-16">{{ $t('investment.subscription_close_time') }}</p>
                <span class="color-black font-16">2023-05-02</span>
              </div>
              <div class="item">
                <p class="color-gray font-16">{{ $t('investment.subscription_effective_time') }}</p>
                <span class="color-black font-16">2023-05-02</span>
              </div>
              <div class="item">
                <p class="color-gray font-16">{{ $t('investment.redemption_open_time') }}</p>
                <span class="color-black font-16">2023-05-02</span>
              </div>
              <div class="item">
                <p class="color-gray font-16">{{ $t('investment.redemption_close_time') }}</p>
                <span class="color-black font-16">2023-05-02</span>
              </div>
              <div class="item">
                <p class="color-gray font-16">{{ $t('investment.redemption_effective_time') }}</p>
                <span class="color-black font-16">2023-05-02</span>
              </div>
              <div class="item">
                <p class="color-gray font-16">{{ $t('investment.lock_period') }}</p>
                <span class="color-black font-16">{{ $t('investment.duration_days', { days: 365 }) }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="label">
          <p class="title">{{ $t('investment.product_data_display') }}</p>
          <div class="chartList">
            <div class="chartBox">
              <div class="_hd">
                <a-tag>{{ $t('investment.unit_net_value_trend') }}</a-tag>
                <a-dropdown>
                  <a-tag>{{ $t('investment.one_month') }}</a-tag>
                  <template #content>
                    <a-option>{{ $t('investment.one_month') }}</a-option>
                    <a-option>{{ $t('investment.three_months') }}</a-option>
                    <a-option>{{ $t('investment.six_months') }}</a-option>
                    <a-option>{{ $t('investment.year_to_date') }}</a-option>
                  </template>
                </a-dropdown>
              </div>
              <div class="canvasBox">
                <canvas></canvas>
              </div>
            </div>
            <div class="chartBox">
              <div class="_hd">
                <a-tag>{{ $t('investment.cumulative_return_trend') }}</a-tag>
                <a-dropdown>
                  <a-tag>{{ $t('investment.one_month') }}</a-tag>
                  <template #content>
                    <a-option>{{ $t('investment.one_month') }}</a-option>
                    <a-option>{{ $t('investment.three_months') }}</a-option>
                    <a-option>{{ $t('investment.six_months') }}</a-option>
                    <a-option>{{ $t('investment.year_to_date') }}</a-option>
                  </template>
                </a-dropdown>
              </div>
              <div class="canvasBox">
                <canvas></canvas>
              </div>
            </div>
            <div class="chartBox">
              <div class="_hd">
                <a-tag>{{ $t('investment.historical_net_value') }}</a-tag>
                <a-dropdown>
                  <a-tag>{{ $t('investment.one_month') }}</a-tag>
                  <template #content>
                    <a-option>{{ $t('investment.one_month') }}</a-option>
                    <a-option>{{ $t('investment.three_months') }}</a-option>
                    <a-option>{{ $t('investment.six_months') }}</a-option>
                    <a-option>{{ $t('investment.year_to_date') }}</a-option>
                  </template>
                </a-dropdown>
              </div>
              <div class="listBox">
                <div class="_cell">
                  <span class="font-12 color-gray">{{ $t('investment.date') }}</span>
                  <span class="font-12 color-gray">{{ $t('investment.unit_net_value') }}</span>
                  <span class="font-12 color-gray">{{ $t('investment.cumulative_return_rate') }}</span>
                </div>
                <a-scrollbar class="scrollBox">
                  <div class="_cell" v-for="i in 30">
                    <span class="font-12 color-black">2023-09-25</span>
                    <span class="font-12 color-black">0.99759137</span>
                    <span class="font-12 color-red">-0.9634 %</span>
                  </div>
                </a-scrollbar>
              </div>
            </div>
            <div class="chartBox">
              <div class="_hd">
                <a-tag>{{ $t('investment.strategy_weight_ratio') }}</a-tag>
                <a-dropdown>
                  <a-tag>{{ $t('investment.one_month') }}</a-tag>
                  <template #content>
                    <a-option>{{ $t('investment.one_month') }}</a-option>
                    <a-option>{{ $t('investment.three_months') }}</a-option>
                    <a-option>{{ $t('investment.six_months') }}</a-option>
                    <a-option>{{ $t('investment.year_to_date') }}</a-option>
                  </template>
                </a-dropdown>
              </div>
              <div class="canvasBox">
                <canvas></canvas>
              </div>
            </div>
          </div>
        </div>
        <div class="label">
          <p class="title">{{ $t('investment.product_rules') }}</p>
          <p class="font-14 color-black rules">{{ $t('investment.fund_interest_start_rule') }}<br>{{ $t('investment.fund_interest_payment_rule') }}<br>{{ $t('investment.fund_redemption_return_rule') }}<br>
            4. 赎回申请：您可以随时发起赎回申请。赎回申请入口：DBG Markets 财富管理主页 > 账户 > 持仓订单 >{{ $t('investment.click_redeem_instruction') }}<br>{{ $t('investment.fund_redemption_waiting_rule') }}<br>{{ $t('investment.fund_historical_return_range_rule') }}</p>
        </div>
      </div>
    </a-layout-content>
    <a-layout-footer>
      <Footer></Footer>
    </a-layout-footer>
  </a-layout>
</template>
<script>
import Footer from "@/components/Footer/footer.vue";
import PageNav from "@/components/PageNav/PageNav.vue";

export default {
  components: {PageNav, Footer},
  data() {
    return {}
  },
  methods: {
    goBack() {
      this.$router.back()
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./fundDetails.scss";
</style>
